// Only existing protected routes can be resumed after login. Role and KYC gates still apply.
const freelancerPaths = new Set(['dashboard', 'my-profile-account-information', 'account', 'my-profile',
    'my-assignments', 'vacancies', 'vacancies-overview', 'documents', 'sp-notify-redirect',
    'choose-package', 'chose-package', 'faqtoring/return', 'invoicing', 'hours-logging', 'hours-logging-rejected',
    // MCP connector consent (add-qportal-mcp-connectors): resumed after sign-in for every role.
    'connect/consent']);
const adminPaths = new Set(['home', 'users', 'users-edit-user', 'users-new-user', 'users-decline-user',
    'hours', 'clients', 'clients-add-new', 'placements', 'edit-placements', 'invoice', 'settings', 'connect/consent']);
// Admin-only resumable paths with an id: the MCP decision confirmation page for a GUID (D format) only.
const adminPathPatterns = [/^connect\/decisions\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/];
const isAdminPath = (path) => adminPaths.has(path) || adminPathPatterns.some((pattern) => pattern.test(path));
export const safeReturnDestination = (value, role) => {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || /[\\\x00-\x20]/.test(value))
        return;
    try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin)
            return;
        const path = url.pathname.slice(1).replace(/\/$/, '').toLowerCase();
        const allowed = role === 'Freelancer' ? freelancerPaths.has(path)
            : role === 'Admin' || role === 'SuperAdmin' ? isAdminPath(path)
                : role === undefined && (freelancerPaths.has(path) || isAdminPath(path));
        return allowed ? url.pathname + url.search + url.hash : undefined;
    }
    catch {
        return;
    }
};
// The existing API returns a configured URL. Treat it as a result, never as a redirect command.
export const emailConfirmationDestination = (value) => {
    if (typeof value !== 'string' || /[\\\x00-\x20]/.test(value) || value.startsWith('//'))
        return;
    try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || url.username || url.password || url.search || url.hash)
            return;
        const path = url.pathname.replace(/\/$/, '');
        if (path === '/email-verification' || path === '/already-verified')
            return path;
        const expired = /^\/code-expired\/([a-zA-Z0-9-]+)$/.exec(path);
        if (expired)
            return '/code-expired?' + new URLSearchParams({ userId: expired[1] }).toString();
    }
    catch {
        return;
    }
};
